import { Box, BoxProps } from '@mui/material';
import clsx from 'clsx';
import React, { useMemo } from 'react';

import { DEFAULT_MARGIN_TEXT } from '../../../Spacer/Spacer';

type GridColumns = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface Props extends BoxProps {
  /**
   * Number of Columns on Mobile
   */
  xs?: GridColumns;

  /**
   * Number of Columns on Mobile
   */
  sm?: GridColumns;

  /**
   * Number of Columns on Tablet
   */
  md: GridColumns;

  /**
   * Number of Columns on Desktop
   */
  lg: GridColumns;

  /**
   * Provide an inner padding
   *
   * Common Rule:
   *   Images have no inner padding
   *   Text has inner padding
   */
  innerPadding?: 'none' | 'both' | 'horizontal' | 'vertical';

  /**
   * Provide a stack concept on the item
   *
   * Common Rule:
   *   Text/Atom following Text/Atom as a padding default gap
   */
  innerSpacing?: 'none' | 'flex-column';
}

const DEFAULT_PADDING = DEFAULT_MARGIN_TEXT; // TODO: theme.option

/**
 * GridItem, a cell with it own live.
 *
 * @parent GridContainer
 * @children Any
 *
 * @constructor
 */
export const FinalGridItem = React.forwardRef<HTMLDivElement, Props>(
  ({ children, xs = 12, sm = 12, md = 12, lg = 12, innerPadding = 'none', innerSpacing = 'none', ...rest }, ref) => {
    const gridColumn = useMemo(
      () => ({ xs: `span ${xs}`, sm: `span ${sm}`, md: `span ${md}`, lg: `span ${lg}` }),
      [xs, sm, md, lg]
    );

    return children ? (
      <Box
        gridColumn={gridColumn}
        className={clsx(`FinalGridItem-xs${xs}-sm${sm}-md${md}-lg${lg}`)}
        paddingY={innerPadding === 'both' || innerPadding === 'vertical' ? DEFAULT_PADDING : 0}
        paddingX={innerPadding === 'both' || innerPadding === 'horizontal' ? DEFAULT_PADDING : 0}
        display={innerSpacing === 'flex-column' ? 'flex' : undefined}
        flexDirection={innerSpacing === 'flex-column' ? 'column' : undefined}
        gap={innerSpacing === 'flex-column' ? DEFAULT_PADDING : undefined}
        ref={ref}
        {...rest}
      >
        {children}
      </Box>
    ) : null;
  }
);

FinalGridItem.displayName = 'FinalGridItem';
